// Firebase initialization using your provided project config.
// This file exports `auth` (Firebase Auth) which the Login component uses.
// If you'd rather keep these values in env vars, replace the literal values
// with process.env.* or import.meta.env.* depending on your setup.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD6OUgK93rb8sUAz2Jg-dw-ZF6CkNrWPao",
  authDomain: "wer-war-dran.firebaseapp.com",
  projectId: "wer-war-dran",
  storageBucket: "wer-war-dran.firebasestorage.app",
  messagingSenderId: "664360538450",
  appId: "1:664360538450:web:a6475abf8d953ac2f36a8b"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;

/*
  Notes:
  - Email/Password sign-in must be enabled in the Firebase Console
    (Authentication → Sign-in method → Email/Password).
  - Keep these credentials out of public repos. For production,
    prefer environment variables and don't commit `.env` files.
*/
